<div id="christmas">
  <div class="christmas_banner" >
    <div class="go_button christmas sm square" style="position:absolute; top:20px; left:20px;">
      <div class="snow share"></div>

      <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
    </div>
  <img src="assets/img/christmas/christmas-banner.jpg" class="img-responsive hidden-xs" alt="">

  <img src="assets/img/christmas/christmas-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md" alt="">

    <div class="snow"></div>
    <div class="games-ball hidden-xs"></div>
  </div>

  <!--<div class="christmasLights"></div>-->


  <ul class="lightrope">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>

  <div class="go_button orange sm square" style="position:absolute; top:20px; left:20px;">
    <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
  </div>


    <perfect-scrollbar class="games-container">
      <div class="cliped-circle-container">
        <a class="cliped-circle" routerLink="./{{game}}" routerLinkActive="active" *ngFor="let game of games">
          <div class="christmas_wreath"></div>
          <div class="circle-background"
               [ngStyle]="{'background-image': 'url(assets/img/christmas/games/'+game+'/sm.jpg)'}"></div>
          <img src="assets/img/games/{{game}}/logo.png" width="80" alt="" style="z-index: 1">
        </a>
      </div>
    </perfect-scrollbar>

  <div class="container">
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!--footer-->
  <div class="christmas_footer">
    <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg" style="width: 80px" alt="GBarena Logo"></a>

    <p>Christmas Event is hosted and powered by GBarena</p>

  </div>
</div>
